function MoneyFormatter(amount) {
    const formattedAmount = parseFloat(amount).toFixed(2);
    const parts = formattedAmount.split('.');
    let intPart = parts[0];
    const decimalPart = parts.length > 1 ? '.' + parts[1] : '';
    let result = '';

    for (let i = intPart.length - 1, count = 0; i >= 0; i--, count++) {
      result = intPart[i] + result;
      if (count % 3 === 2 && i !== 0) {
        result = ',' + result;
      }
    }
    return `$${result}${decimalPart}` || `$${0}`
  }

  export default MoneyFormatter;